<template>
  <div class="qir-faq__wrapper">
    <h2 class="qir-faq__title title">
      Frequently Asked Questions
    </h2>

    <title-description-list
      :items="$options.consts.LIST_ITEMS"
      class="qir-faq__list"
    >
      <template #title="{ title }">
        <span class="qir-faq__list-item-title">{{ title }}</span>
      </template>

      <template #description="{ description }">
        <span class="qir-faq__list-item-description text-caption">
          {{ description }}
        </span>
      </template>
    </title-description-list>
  </div>
</template>

<script>
import TitleDescriptionList from 'sections/_shared/TitleDescriptionList/index.vue'

export default {
  name: 'QirFaq',
  components: { TitleDescriptionList },
  consts: {
    LIST_ITEMS: [
      {
        title: 'What is included in the Quarterly Intelligence Report?',
        description:
          'The report covers key areas such as FX/CFD trading volumes, broker rankings, regulatory updates, regional insights, and cryptocurrency trends. It also features expert interviews, payment industry analyses, and social media benchmarks.'
      },
      {
        title: 'How often are the reports published?',
        description:
          'The Quarterly Intelligence Reports are published every quarter. We announce each release on our website, social media, and via email to our subscribers.'
      },
      {
        title: 'How do I access the report after payment?',
        description:
          'After the payment is settled, you will receive an immediate confirmation and the report link via email.'
      },
      {
        title: 'Who buys the Quarterly Intelligence Report?',
        description:
          'The report is used by brokers, fintech firms, liquidity providers, investors, analysts, and regulators seeking a clear, verified view of the retail trading market.'
      },
      {
        title: 'Are there more reports available?',
        description:
          'Yes, we have reports dating back to Q1 2017 available on our online platform. You can also request a custom report tailored to your specific needs.'
      },
      {
        title: 'Can I preview the report before purchasing?',
        description:
          'We provide a brief summary of the report’s content on our website. This allows you to review the key insights and topics covered before making a purchase decision.'
      }
    ]
  }
}
</script>

<style lang="scss" scoped>
@import '~assets/scss/local/mixins/grid';

.qir-faq__wrapper {
  $padding: (
    $above-desktop-xl: 96px 0,
    $desktop-md: 64px 0,
    $mobile: 32px 0
  );

  @include setStyleByBreakpoint('padding', $padding);

  .qir-faq__title {
    $margin-bottom: (
      $above-desktop-xl: 64px,
      $desktop-md: 32px,
      $mobile: 24px
    );

    @include setStyleByBreakpoint('margin-bottom', $margin-bottom);
  }

  .qir-faq__list {
    $grid-setup: (
      $columnSetup: (
        $above-desktop-xl: repeat(3, minmax(0, 100%)),
        $tablet: repeat(2, minmax(0, 100%)),
        $mobile: minmax(0, 100%)
      ),
      $columnGapSetup: (
        $above-desktop-xl: 64px
      ),
      $rowGapSetup: (
        $above-desktop-xl: 64px,
        $mobile: 24px
      )
    );

    @include gridBuilder($grid-setup);
  }

  .qir-faq__list-item-title {
    $font-size: (
      $above-desktop-xl: 18px
    );

    $line-height: (
      $above-desktop-xl: 28px
    );

    @include setStyleByBreakpoint('line-height', $line-height);
    @include setStyleByBreakpoint('font-size', $font-size);
  }
}
</style>
